export const footer = () => {
    const $ = jQuery;
    
    const headings = $('#sitewide-footer .footer-column > .h3');

    headings.on('click', (e) => {
        const clicked = $(e.currentTarget);

        if (clicked.hasClass('open')) {
            clicked.removeClass('open');
            clicked.next().slideUp();
        } else {
            const open = headings.filter('.open');

            if (open.length === 1) {
                $(open[0]).removeClass('open').next().slideUp();
            }

            clicked.addClass('open');
            clicked.next().slideDown();
        }
    });
};